module.exports = __webpack_public_path__ + "static/media/eofy_everyday_digital_and_weekend_papers.91ecfcd6.png";